import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { JavapiService } from '../../services/javapi.service';
import { MetodosgenService } from '../../services/metodosgen.service';
import { firstValueFrom } from 'rxjs';
import { TrabajosmenuComponent } from '../trabajosmenu/trabajosmenu.component';
import { Metodosui } from '../../services/metodosui';

@Component({
  selector: 'app-trabajoslist',
  templateUrl: './trabajoslist.component.html',
  styleUrls: ['./trabajoslist.component.scss'],
  standalone: false
})
export class TrabajoslistComponent implements OnInit {

  @Input() cotizacion: any = null;
  @Input() selectionMode: boolean = false;

  trabajos: any[] = [];
  displayedTrabajos: any[] = [];
  searchText: string = '';
  isLoading: boolean = true;
  showSearch: boolean = false;

  constructor(
    private modalCtrl: ModalController,
    private javapiService: JavapiService,
    private metodosGenService: MetodosgenService,
    private metodosui: Metodosui
  ) { }

  async ngOnInit() {
    this.loadTrabajos();
  }

  close() {
    this.modalCtrl.dismiss();
  }

  async loadTrabajos(silent: boolean = false) {
    if (!silent) this.isLoading = true;
    try {
      let payload;
      if (this.selectionMode) {
        // spr1 = cliente, spr2 = lugar
        payload = this.metodosGenService.setModeloGeneral(
          "genModel", "trabajosSinCotizacion", this.cotizacion?.cliente || '', this.cotizacion?.direccion || '', '', '', '', '', '', '', '', '', '', '', '', '', ''
        );
      } else {
        payload = this.metodosGenService.setModeloGeneral(
          "genModel", "trabajos", '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''
        );
      }

      const resp: any = await firstValueFrom(this.javapiService.getCommonModel(payload));

      this.trabajos = (resp || []).map((item: any) => ({
        id: Number(item.dt1) || 0,
        cliente: item.dt2 ?? '',
        lugar: item.dt3 ?? '',
        descripcion: item.dt4 ?? '',
        solicitante: item.dt5 ?? '',
        incluye_material: item.dt6 ?? 'Y',
        estado: item.dt7 ?? '',
        fecha_creacion: item.dt8 ?? '',
        isArsSigned: item.dt9 === 'Y' || item.dt9 === true || item.dt9 === 1,
        hasArsAttachment: !!item.dt10
      }));

      this.applyFilters();
    } catch (e) {
      console.error('Error loading trabajos:', e);
    } finally {
      this.isLoading = false;
    }
  }

  applyFilters() {
    if (!this.searchText.trim()) {
      this.displayedTrabajos = [...this.trabajos];
    } else {
      const q = this.searchText.toLowerCase();
      this.displayedTrabajos = this.trabajos.filter(t =>
        String(t.id).includes(q) ||
        t.cliente.toLowerCase().includes(q) ||
        t.lugar.toLowerCase().includes(q) ||
        t.descripcion.toLowerCase().includes(q)
      );
    }
  }

  search(event: any) {
    this.searchText = event.detail.value;
    this.applyFilters();
  }

  toggleSearch() {
    this.showSearch = !this.showSearch;
    if (!this.showSearch) {
      this.searchText = '';
      this.applyFilters();
    }
  }

  async openMenu(trabajo: any) {
    if (this.selectionMode) {
      this.confirmLink(trabajo);
    } else {
      const modal = await this.modalCtrl.create({
        component: TrabajosmenuComponent,
        componentProps: { trabajo }
      });
      await modal.present();
    }
  }

  async confirmLink(trabajo: any) {
    const ok = await this.metodosui.showConfirmation(
      'Vincular Trabajo',
      `¿Deseas vincular esta cotización al Trabajo #${trabajo.id} de ${trabajo.cliente}?`,
      'Vincular'
    );
    if (ok) {
      this.modalCtrl.dismiss({ selectedTrabajo: trabajo });
    }
  }

  getEstadoColor(estado: string): any {
    const e = (estado || '').toLowerCase();
    if (e === 'finalizado' || e === 'terminado') return { background: 'rgba(39, 174, 96, 0.12)', color: '#27ae60' };
    if (e === 'en proceso' || e === 'ejecucion') return { background: 'rgba(52, 152, 219, 0.12)', color: '#2980b9' };
    if (e === 'pendiente') return { background: 'rgba(243, 156, 18, 0.12)', color: '#f39c12' };
    if (e === 'cancelado') return { background: 'rgba(231, 76, 60, 0.12)', color: '#e74c3c' };
    return { background: 'rgba(149, 165, 166, 0.12)', color: '#7f8c8d' };
  }
}
